import { type WorkflowRun } from '@mastra/core/storage';

const readRunStatus = (run: WorkflowRun): string | null => {
    const snapshot: unknown = run.snapshot;
    if (snapshot == null || typeof snapshot !== 'object') {
        return null;
    }

    const status: unknown = Object.getOwnPropertyDescriptor(
        snapshot,
        'status',
    )?.value;

    return typeof status === 'string' ? status : null;
};

/**
 * Replay is offered when a transcript is stored and every existing run failed.
 * A running, suspended, or succeeded run makes production skip the new start,
 * so the button would look successful and do nothing.
 */
export const canReplayStoredTranscript = (
    transcriptS3Key: string | null | undefined,
    runs: WorkflowRun[],
): boolean => {
    if (transcriptS3Key == null || transcriptS3Key.length === 0) {
        return false;
    }

    return runs.every((run) => readRunStatus(run) === 'failed');
};
